import { useState } from 'react';
import { Label, Error, Icon, ClassHelper } from 'components/lib';
import Style from './input.tailwind.js';
import { useTranslate } from 'app/translations.js';

export function URLInput(props){
  const { _t } = useTranslate();
  const [error, setError] = useState(

    props.errorMessage || _t('url.empty')

  );

  function validate(e){

    let value = e ? e.target.value : '';
    let valid = undefined;

    // input is required and value is blank
    if (props.required && value === '')
      valid = false;

    // input isn't required and value is blank
    if (!props.required && value === '')
      valid = true;

    // test for a valid url
    const rex = /^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9-]+(\.[a-z-]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/;

    if (rex.test(value)){

      valid = true;

    }
    else {

      valid = false;
      setError(_t('url.invalid'));

    }

    // update the parent form
    props.onChange(props.name, value, valid);

  }

  // style
  const urlStyle = ClassHelper(Style, {

    textbox: true, 
    className: props.className, 
    error: props.valid === false, 
    success: props.valid === true,
    warning: props.warning
    
  });

  return(
    <div className={ Style.input }>

      { props.label && 
        <Label
          text={ props.label }
          required={ props.required }
          for={ props.name }
        /> }

      {/* The check is positioned against this wrapper, not the whole
          block, so it stays centred on the control with or without a
          label. */}
      <div className={ Style.field }>

        <input
          type='url'
          id={ props.id }
          name={ props.name }
          className={ urlStyle }
          value={ props.value || '' }
          placeholder={ props.placeholder }
          onChange={ e => props.onChange(props.name, e.target.value, undefined) }
          onBlur={ e => validate(e) }
        />

        { props.valid === true &&
          <Icon
            image='check'
            color='currentColor'
            className={ Style.successIcon }
            size={ 16 }
          /> }

      </div>

      { props.valid === false &&
        <Error message={ error }/> }

    </div>
  );
}
